import { request } from '../request';
import { useSettingsStore } from '../../stores';

export interface ApiMessageRes {
  limit: number;
  list: {
    content: string;
    isRead: boolean;
    systemCode: string;
    title: string;
    type: number;
    _id: string;
  }[];
  page: number;
  total: number;
  unreadCount: number;
}

/**
 * 查询通知列表
 * @param params
 * @returns
 */
export const queryNoticeList = async (params: any) => {
  const { settings } = useSettingsStore();

  const url = settings.personalCenter.find(x => x.id === 'notice')?.queryNoticeUrl
  try {
    const res = await request<ApiMessageRes>({
      url: url || '/message',
      method: 'get',
      params,
    });
    return res;
  } catch (error) {
    return {
      success: false,
      obj: {
        limit: 0,
        list: [],
        page: 0,
        total: 0,
        unreadCount: 0,
      } as ApiMessageRes,
    };
  }
};

/**
 * 新增通知
 * @param data
 * @returns
 */
export const addNotice = async (data: any) => {
  try {
    const res: any = await request<ApiMessageRes['list'][0]>({
      url: '/message/create',
      method: 'post',
      data: data,
    });
    return res;
  } catch (error) {
    return {
      success: false,
    };
  }
};

/**
 * 新增通知(mock)
 * @param data
 * @returns
 */
export const addMockNotice = async () => {
  try {
    const res: any = await request<ApiMessageRes['list'][0]>({
      url: '/message/test',
      method: 'post',
    });
    return res;
  } catch (error) {
    return {
      success: false,
    };
  }
};

/**
 * 消息已读
 * @param data
 * @returns
 */
export const readNotice = async (data: any) => {
  const { settings } = useSettingsStore();

  const url = settings.personalCenter.find(x => x.id === 'notice')?.readNoticeUrl
  try {
    const res: any = await request<ApiMessageRes['list'][0]>({
      url: url || '/message/read',
      method: 'post',
      data,
    });
    return res;
  } catch (error) {
    return {
      success: false,
    };
  }
};
